import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

// import axios from 'axios';
import axios from '../globalAxios';
import { uniq, sortBy } from 'lodash';
import { appConfig } from '../../config';

import Style, { DeliveryWindow, mapStyles } from 'molo-shared/lib/models/Style';
import {
    buildCollectionMastersCacheKey,
    getCachedCollectionMasters,
    setCachedCollectionMasters,
} from './collectionMastersCache';

const baseUrl = appConfig.api.baseUrl;

/** Case-insensitive A–Z by `collectionName` (new array, does not mutate input). */
export function sortCollectionsAlphabetically(collections: any[]): any[] {
    if (!Array.isArray(collections)) {
        return [];
    }
    return sortBy(collections, [(c: any) => String((c && c.collectionName) || '').toLowerCase()]);
}

export interface IGetCollections {
    type: 'FETCH_COLLECTIONS_SUCCESS',
    collections: any[]
    /** Which order type this list belongs to (for cache / mismatch refetch). */
    collectionsOrderType?: string
}

export interface IGetCollectionMaster {
    type: 'FETCH_COLLECTION_MASTER_SUCCESS',
    styles: any[]
}

export interface SetFetcingCollectionMasters {
    type: 'SET_FETCHING_COLLECTION_MASTERS'
    isFetching: boolean
}

export interface SetFetchingCollections {
    type: 'SET_FETCHING_COLLECTIONS'
    isFetching: boolean
}

export interface ISetDeliveryWindows {
    type: 'SET_DELIVERY_WINDOWS_SUCCESS',
    deliveryWindows: DeliveryWindow[]
}

export type CollectionsActions =
    | IGetCollections
    | IGetCollectionMaster
    | SetFetcingCollectionMasters
    | SetFetchingCollections
    | ISetDeliveryWindows

// Action Creators
export const getCollectionsSuccess = (collections: any[], collectionsOrderType?: string): IGetCollections => {
    return { type: 'FETCH_COLLECTIONS_SUCCESS', collections, collectionsOrderType }
}

export const getCollectionMasterSuccess = (styles: Style[]): IGetCollectionMaster => {
    return { type: 'FETCH_COLLECTION_MASTER_SUCCESS', styles }
}

export const setFetcingCollectionMasters = (isFetching: boolean) => {
    return { type: 'SET_FETCHING_COLLECTION_MASTERS', isFetching }
}

export const setFetchingCollections = (isFetching: boolean): SetFetchingCollections => {
    return { type: 'SET_FETCHING_COLLECTIONS', isFetching }
}

export const setDeliveryWindowsSuccess = (deliveryWindows: DeliveryWindow[]): ISetDeliveryWindows => {
    return { type: 'SET_DELIVERY_WINDOWS_SUCCESS', deliveryWindows }
}

export const getCollections = (orderType: string): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        const url = baseUrl + 'OrderTypes/GetOrderTypeCollections'
        dispatch(setFetchingCollections(true))

        try {
            const response = await axios.post(url, null, {params: { orderTypeName: orderType }});
            const collections = sortCollectionsAlphabetically(response.data);
            dispatch(getCollectionsSuccess(collections, orderType))
        } catch (e) {

        } finally {
            dispatch(setFetchingCollections(false))
        }
    }
}

export const getCollectionMasters = (orderType: string, collectionName: string, currencyCode: string, pricegroup: string): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        const cacheKey = buildCollectionMastersCacheKey(orderType, collectionName, currencyCode, pricegroup);
        const cached = getCachedCollectionMasters(cacheKey);
        if (cached) {
            dispatch(getCollectionMasterSuccess(cached));
            await dispatch(setDeliveryWindows(cached));
            return;
        }

        const url = baseUrl + 'Items/GetCollectionMasters';
        dispatch(setFetcingCollectionMasters(true));

        try {
            const response = await axios.post(url, null, {params: { orderType, collectionName, currencyCode, pricegroup }});
            let styles = mapStyles(response.data);

            // Hack - should be removed(TS)
            if (orderType === 'PRE-ORDER S22') {
                // styles = styles.filter(style => style.navCollection.includes('22'))
            }

            setCachedCollectionMasters(cacheKey, styles);
            dispatch(getCollectionMasterSuccess(styles));
            dispatch(setDeliveryWindows(styles));
        } catch (e) {
            console.log(e, '**ERROR**');
        } finally {
            dispatch(setFetcingCollectionMasters(false));
        }
    }
}

export const setDeliveryWindows = (products: Style[]): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        const allDeliveryWindows = products.map(style => style.deliveryWindow);
        const deliveryWindows: DeliveryWindow[] = [];
        const uniqueWindows = uniq(allDeliveryWindows.map(window => window.window));

        for (const key of uniqueWindows) {
            const window = allDeliveryWindows.find(window => window.window === key);
            if (window) {
                deliveryWindows.push(window);
            }
        }

        const windows = sortBy(deliveryWindows, 'sort')

        dispatch(setDeliveryWindowsSuccess(windows));
    }
}

export class CollectionApi {
    static getCollectionMasters = async (orderType: string, collectionName: string, currencyCode: string, pricegroup: string) => {
        const url = baseUrl + 'Items/GetCollectionMasters'
        console.log('getCollectionMasters');
        return await axios.post(url, null, {params: { orderType, collectionName, currencyCode, pricegroup }});
    }

    static getCollections = async (orderTypeName: string) => {
        const url = baseUrl + 'OrderTypes/GetOrderTypeCollections'
        return await axios.post(url, null, {params: { orderTypeName }});
    }
}
